@if (!isLoading) {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Rediger serviceabonnement</h1>
  <button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
    <mat-icon class="material-icons">close</mat-icon>
  </button>
  <div mat-dialog-content>
    <form [formGroup]="form" autocomplete="off">
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Beskrivelse</mat-label>
          <input formControlName="description" matInput />
        </mat-form-field>
      </div>
      @if (!serviceAbonnement.isTilkaldsabonnement) {
        <div class="form-row">
          <mat-form-field appearance="outline">
            <mat-label>Fakturatekst</mat-label>
            <input formControlName="fakturaDescription" matInput />
          </mat-form-field>
        </div>
      }
      @if (!serviceAbonnement.isTilkaldsabonnement) {
        <div class="form-row no-margin-bottom">
          <mat-form-field appearance="outline">
            <mat-label>Varenummer</mat-label>
            <input formControlName="okKundeVarenr" matInput />
          </mat-form-field>
        </div>
      }
      @if (!serviceAbonnement.isTilkaldsabonnement) {
        <div class="form-row no-margin-bottom">
          <mat-form-field appearance="outline">
            <mat-label>Opkrævningsinterval</mat-label>
            <input formControlName="opkraevningsinterval" matInput />
          </mat-form-field>
          @if (form.errors?.opkraevningsinterval) {
            <mat-error>
              Abonnementets Eftersynsinterval skal være deleligt med det angivne Opkraevningsinterval.
            </mat-error>
          }
          @if (!form.errors?.opkraevningsinterval && opkraevningsinterval.dirty && serviceaftaleCount) {
            <mat-error class="orange">
              Ændring af opkrævningsinterval kan tage flere minutter.
            </mat-error>
          }
        </div>
      }
    </form>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button (click)="cancel()">Fortryd</button>
    <button [disabled]="!form.valid" mat-raised-button color="primary" (click)="update()">Gem</button>
  </div>
}
@if (isLoading) {
  <div mat-dialog-content class="excel__download flex-wrap flex-wrap--center">
    <div mat-dialog-content>
      <p class="orange med-text align-center">
        <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
        <br />
        <span>
          Opdaterer serviceabonnement
          <!-- <span *ngIf="serviceaftaleCount > 0">og {{ serviceaftaleCount }} serviceaftaler</span> -->
          - Dette kan tage flere minutter. Vent venligst
        </span>
      </p>
      <div class="flex margin--top-l margin--bottom-l align-center">
        <div class="loading loading--dark"></div>
      </div>
    </div>
  </div>
}
